/**
 * Shared fetch wrapper that detects session timeout responses from the gateway
 * (STIG V-222389). When a 401 response includes the `X-Session-Timeout: true`
 * header, dispatches a `session-timeout` CustomEvent on `window` so any
 * listener (AuthContext) can trigger logout + redirect.
 *
 * All openapi-fetch clients and standalone fetch wrappers should use this as
 * their `fetch` implementation to ensure consistent timeout handling across
 * the entire frontend.
 *
 * @example
 * ```ts
 * import { fetchWithTimeout } from '@/lib/fetchWithTimeout'
 * const client = createClient<paths>({ baseUrl: '/', fetch: fetchWithTimeout })
 * ```
 */
export const fetchWithTimeout: typeof fetch = async (input, init) => {
  const response = await fetch(input, init)

  if (response.status === 401 && response.headers.get('X-Session-Timeout') === 'true') {
    window.dispatchEvent(new CustomEvent('session-timeout'))
  }

  return response
}
